const ToastPopup = {
    success: (message) => {
      window.showToast(message, 'success');
    },
    error: (message) => {
      window.showToast(message, 'error');
    },
    warn: (message) => {
      window.showToast(message, 'warning');
    },
    info: (message) => {
      window.showToast(message, 'info');
    },
};

export default ToastPopup;
